import { Id, Store, UserRole } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertUserRoleToQueryParam } from './shared/convert'
import { removeUserFromCache } from './shared/util'

export function useDeleteUser() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: deleteUser,
    onSuccess: async (_, { userId, role, companyId }) => {
      await removeUserFromCache(client, userId, role, companyId)
    },
  })

  function deleteUser({
    userId,
    role,
    stores,
    companyId,
  }: {
    userId: Id
    role: UserRole | undefined
    stores: Store[] | undefined
    companyId?: string
  }) {
    const body = getBody(role, stores)
    return server.put(getUrl(userId, role, companyId), body)
  }

  function getBody(role: UserRole | undefined, stores: Store[] | undefined) {
    if (role === 'observer') {
      return stores?.map(store => Number(store.id)) ?? []
    } else if (role === 'staff' || role === 'guest') {
      const roleParam = convertUserRoleToQueryParam(role)
      if (roleParam) {
        return { role: roleParam }
      }
    }
    throw new Error('Role invalid')
  }
}

function getUrl(userId: Id, role: UserRole | undefined, companyId?: string) {
  if (!companyId) {
    throw new Error('Company id invalid')
  }
  if (role === 'observer') {
    return `/v2/users/observers/deactivate/${companyId}/${userId}`
  } else if (role === 'staff' || role === 'guest') {
    return `/v2/users/${companyId}/${userId}`
  }
  throw new Error('Role invalid')
}
